/* ===========================================================
   lib/icons.js — the icon set (24×24 stroke paths)

   Drawn in the style of Lucide (ISC licence): simple outlined
   shapes that read at 16–20 px. Each icon is a list of path data.
   =========================================================== */

export const ICONS = {
  menu: ['M4 6h16', 'M4 12h16', 'M4 18h16'],
  search: ['M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14z', 'M20 20l-4-4'],
  plus: ['M12 5v14', 'M5 12h14'],
  close: ['M6 6l12 12', 'M18 6L6 18'],
  back: ['M15 18l-6-6 6-6'],
  chevron: ['M6 9l6 6 6-6'],
  more: ['M12 6h.01', 'M12 12h.01', 'M12 18h.01'],
  undo: ['M9 14L4 9l5-5', 'M4 9h11a5 5 0 0 1 0 10h-3'],
  redo: ['M15 14l5-5-5-5', 'M20 9H9a5 5 0 0 0 0 10h3'],
  bold: ['M7 5h6a3.5 3.5 0 0 1 0 7H7z', 'M7 12h7a3.5 3.5 0 0 1 0 7H7z'],
  italic: ['M19 4h-9', 'M14 20H5', 'M15 4L9 20'],
  underline: ['M7 4v6a5 5 0 0 0 10 0V4', 'M5 20h14'],
  strike: ['M16 6.5C15 5 13.6 4.5 12 4.5c-2.5 0-4 1.3-4 3 0 3.5 8 2.5 8 6.5 0 1.9-1.7 3.5-4.2 3.5-1.9 0-3.4-.7-4.3-2', 'M4 12h16'],
  highlight: ['M9 11l-5 5v3h3l5-5', 'M14 4l6 6-8 8-6-6z'],
  link: ['M10 14a4 4 0 0 0 5.66 0l3-3a4 4 0 0 0-5.66-5.66l-1 1', 'M14 10a4 4 0 0 0-5.66 0l-3 3a4 4 0 0 0 5.66 5.66l1-1'],
  unlink: ['M9 15l-1 1a3 3 0 0 1-4-4l1-1', 'M15 9l1-1a3 3 0 0 1 4 4l-1 1', 'M3 3l18 18'],
  bullets: ['M9 6h11', 'M9 12h11', 'M9 18h11', 'M4.5 6h.01', 'M4.5 12h.01', 'M4.5 18h.01'],
  numbers: ['M10 6h10', 'M10 12h10', 'M10 18h10', 'M4 6h1v4', 'M4 10h2', 'M6 18H4c0-1 2-2 2-3s-1-1.5-2-1'],
  checklist: ['M4 6l1.5 1.5L8 5', 'M4 12l1.5 1.5L8 11', 'M4 18l1.5 1.5L8 17', 'M11 6h9', 'M11 12h9', 'M11 18h9'],
  quote: ['M7 7h4v4c0 3-2 5-4 6', 'M14 7h4v4c0 3-2 5-4 6'],
  table: ['M4 5h16v14H4z', 'M4 10h16', 'M4 15h16', 'M10 5v14'],
  image: ['M4 5h16v14H4z', 'M4 16l5-5 4 4 2-2 5 5', 'M15.5 9.5h.01'],
  equation: ['M5 6h7', 'M8.5 6v12', 'M14 10l5 6', 'M19 10l-5 6', 'M5 18h4'],
  divider: ['M4 12h16'],
  code: ['M8 8l-4 4 4 4', 'M16 8l4 4-4 4', 'M14 5l-4 14'],
  play: ['M7 5l12 7-12 7z'],
  stop: ['M7 7h10v10H7z'],
  eraser: ['M7 20h13', 'M5 16l9-9 5 5-6 6H8z'],
  sandbox: ['M4 5h16v14H4z', 'M4 9h16', 'M8 13l-2 2 2 2', 'M16 13l2 2-2 2'],
  alignLeft: ['M4 6h16', 'M4 10h10', 'M4 14h16', 'M4 18h10'],
  alignCenter: ['M4 6h16', 'M7 10h10', 'M4 14h16', 'M7 18h10'],
  alignRight: ['M4 6h16', 'M10 10h10', 'M4 14h16', 'M10 18h10'],
  clearFormat: ['M6 5h12', 'M12 5l-4 14', 'M15 15l5 5', 'M20 15l-5 5'],
  share: ['M16 6l-4-4-4 4', 'M12 2v13', 'M5 12v7h14v-7'],
  history: ['M3 12a9 9 0 1 0 3-6.7L3 8', 'M3 3v5h5', 'M12 7v5l3 2'],
  copy: ['M9 9h11v11H9z', 'M5 15H4V4h11v1'],
  branch: ['M6 3v12', 'M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M18 9a9 9 0 0 1-9 9'],
  merge: ['M6 3v18', 'M6 9c0 4 6 4 9 8', 'M15 17h4v-4'],
  compare: ['M4 5h7v14H4z', 'M13 5h7v14h-7z'],
  trash: ['M4 7h16', 'M9 7V4h6v3', 'M6 7l1 13h10l1-13'],
  restore: ['M4 12a8 8 0 1 0 2.3-5.6L4 8.6', 'M4 4v4.6h4.6'],
  download: ['M12 4v11', 'M7 10l5 5 5-5', 'M5 20h14'],
  upload: ['M12 20V9', 'M7 14l5-5 5 5', 'M5 4h14'],
  folder: ['M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'],
  file: ['M6 3h8l4 4v14H6z', 'M14 3v4h4'],
  doc: ['M6 3h8l4 4v14H6z', 'M14 3v4h4', 'M9 12h6', 'M9 16h6'],
  computer: ['M4 5h16v11H4z', 'M9 20h6', 'M12 16v4'],
  settings: ['M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z'],
  star: ['M12 3l2.8 5.8 6.2.9-4.5 4.4 1 6.2L12 17.4 6.5 20.3l1-6.2L3 9.7l6.2-.9z'],
  user: ['M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M4 21a8 8 0 0 1 16 0'],
  users: ['M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M2 21a7 7 0 0 1 14 0', 'M16 3.5a4 4 0 0 1 0 7', 'M22 21a7 7 0 0 0-5-6.7'],
  globe: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M3 12h18', 'M12 3a14 14 0 0 1 0 18', 'M12 3a14 14 0 0 0 0 18'],
  lock: ['M6 11h12v10H6z', 'M8 11V7a4 4 0 0 1 8 0v4'],
  eye: ['M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z', 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'],
  pencil: ['M4 20h4L19 9l-4-4L4 16z', 'M13.5 6.5l4 4'],
  music: ['M9 18V6l11-2v12', 'M9 18a3 3 0 1 1-3-3 3 3 0 0 1 3 3z', 'M20 16a3 3 0 1 1-3-3 3 3 0 0 1 3 3z'],
  pause: ['M8 5v14', 'M16 5v14'],
  cloudSun: ['M12 3v1.5', 'M5.6 5.6l1 1', 'M18.4 5.6l-1 1', 'M8.5 11a3.5 3.5 0 0 1 6.8-1.2', 'M7 20h10a3.5 3.5 0 0 0 .4-7 5 5 0 0 0-9.6 1.2A3 3 0 0 0 7 20z'],
  shuffle: ['M3 7h4l10 10h4', 'M3 17h4l3-3', 'M14 10l3-3h4', 'M18 4l3 3-3 3', 'M18 14l3 3-3 3'],
  check: ['M5 12l5 5L20 7'],
  cloud: ['M7 18a5 5 0 1 1 1-9.9A6 6 0 0 1 19.6 10 4 4 0 0 1 18 18z'],
  cloudOff: ['M3 3l18 18', 'M8.6 8.6A5 5 0 0 0 7 18h10', 'M19.6 10A4 4 0 0 1 21 16', 'M10.5 5.2A6 6 0 0 1 19.6 10'],
  wifi: ['M5 12.5a10 10 0 0 1 14 0', 'M8.5 16a5 5 0 0 1 7 0', 'M12 19.5h.01'],
  sun: ['M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z', 'M12 1v2', 'M12 21v2', 'M4.2 4.2l1.4 1.4', 'M18.4 18.4l1.4 1.4', 'M1 12h2', 'M21 12h2', 'M4.2 19.8l1.4-1.4', 'M18.4 5.6l1.4-1.4'],
  moon: ['M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8z'],
  markdown: ['M3 6h18v12H3z', 'M6 15V9l2.5 3L11 9v6', 'M15 9v6', 'M13 13l2 2 2-2'],
  print: ['M6 9V3h12v6', 'M6 18H4v-7h16v7h-2', 'M6 14h12v7H6z'],
  info: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M12 11v6', 'M12 7.5h.01'],
  keyboard: ['M3 6h18v12H3z', 'M7 10h.01', 'M11 10h.01', 'M15 10h.01', 'M7 14h10'],
  logout: ['M9 21H5V3h4', 'M16 17l5-5-5-5', 'M21 12H9'],
  heading: ['M6 4v16', 'M18 4v16', 'M6 12h12'],
  text: ['M5 6V4h14v2', 'M12 4v16', 'M9 20h6'],
  refresh: ['M21 12a9 9 0 0 1-15.5 6.2L3 16', 'M3 21v-5h5', 'M3 12a9 9 0 0 1 15.5-6.2L21 8', 'M21 3v5h-5'],
  open: ['M14 4h6v6', 'M20 4l-9 9', 'M18 14v6H4V6h6'],
  sparkle: ['M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z'],
};
